/* eslint-disable multiline-ternary */

import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import { PhotoCol, StyledImg } from './styles';
import resolveFrPhoto from '../../../../assets/js/utils/resolveFrPhoto.util';
import { PHONE_MEDIA_QUERY } from '../../../../assets/js/constants/media_query.constants';
import RepPhoneNumber from '../../../../assets/js/components/nm_rep_phone_number.component'; // TODO: move and rename this
import NMEnsemble from '../../../../assets/js/components/nm_ensemble.component'; // TODO: move and rename this
import AgentForm from '../../../forms/AgentForm';
import { Row, Col } from '../../../base/Grid';
import Button from '../../../base/Button';
import Link from '../../../base/Link';
import Typography from '../../../base/Typography';
import breakpoints from '../../../theme/breakpoints';

const isMobileWindow = (width) => {
  if (width > breakpoints.values.small) {
    return false;
  }
  return true;
};

const AgentCard = ({
  agentObject,
  config,
  floodlightsendto,
  campaign,
  source,
  topic,
  photoWidth,
}) => {
  const isMobile = typeof window !== 'undefined' ? isMobileWindow(window.innerWidth) : false;
  const [isExpanded, setIsExpanded] = useState(false);
  const rep = agentObject;
  const [typographyVariant, setTypographyVariant] = useState(isMobile ? 'h1' : 'h3');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // browser-only code - react-static has some server side rendering for build process
      window.addEventListener(
        'resize',
        throttle(() => {
          const mobile = isMobileWindow(window.innerWidth);
          setTypographyVariant(mobile ? 'h1' : 'h3');
        }, 100),
      );
    }
  }, []);

  const toggle = () => {
    setIsExpanded(!isExpanded);
  };

  const getStandardizedTitle = () => {
    if (rep.type === 'MD') {
      return 'Managing Director';
    }

    return rep.title;
  };

  const getFormattedAddress = () => {
    const addressPieces = [];

    if (rep.street) addressPieces.push(rep.street);
    if (rep.building) addressPieces.push(rep.building);

    addressPieces.push(`\n${rep.city}, ${rep.state}`);

    if (rep.zipLastFour) {
      addressPieces.push(`${rep.zip}-${rep.zipLastFour}`);
    } else {
      addressPieces.push(rep.zip);
    }

    return addressPieces.join(' ');
  };

  return (
    <div className='nmx-search-rep-card vcard'>
      <Row className={isExpanded && 'is-expanded'}>
        <PhotoCol xsmall={12} small={4} medium={3} nestedChild>
          <Row>
            <Col xsmall={12} small={12} medium={12} nested>
              <StyledImg src={resolveFrPhoto(rep)} photoWidth={photoWidth} alt={rep.fullName} className='fr-photo photo' />
            </Col>
          </Row>
        </PhotoCol>
        <Col xsmall={12} small={8} medium={9} nestedChild>
          <Row>
            <Col xsmall={12} small={12} medium={6} nested styles={{ marginBottom: '1rem' }}>
              {/* TODO: parse out name for microformats "given-name", "family-name", etc */}
              <Typography className='fr-name n' component='h3' variant={typographyVariant} styles={{ paddingBottom: '1rem' }}>
                <span className="fn">{rep.fullName}</span>
              </Typography>
              <span className='fr-title'>{getStandardizedTitle(rep)}</span>
              <NMEnsemble agentnumber={rep.id}></NMEnsemble>
              <ul className='fr-professional-designations reduced' style={{ padding: '1rem 0' }}>
                {rep.designations && rep.designations.map((designation, index) => (
                  <li key={index} className='fr-professional-designation'>
                    <span>{designation}{index < rep.designations.length - 1 && ', '}</span>
                  </li>
                ))}
              </ul>
              <Link href='https://brokercheck.finra.org/' target='_blank' rel='nofollow noopener noreferrer'>FINRA BrokerCheck</Link>
            </Col>
            <Col xsmall={12} small={12} medium={6} nested>
              {/* TODO: formatted address needs some love, needs microformats */}
              <address className="nmx-p fr-address adr location value">{getFormattedAddress(rep)}</address>
              {rep.selectedPhone1
                ? <RepPhoneNumber phoneNumber={rep.selectedPhone1.Number}/>
                : false}
              {rep.selectedPhone2
                ? <RepPhoneNumber phoneNumber={rep.selectedPhone2.Number}/>
                : false}
              {rep.selectedPhone3
                ? <RepPhoneNumber phoneNumber={rep.selectedPhone3.Number}/>
                : false}
              <ul className='fr-contact-links reduced'>
                {rep.slug && (
                  <li className='fr-contact-link-container'>
                    <Link href={`/financial/advisor/${rep.slug}/`} aria-label={`Link to ${rep.fullName} profile page`} className='fr-contact-link'>view my profile page</Link>
                  </li>
                )}
              </ul>
              <Button variant='secondary' className='fr-contact-cta' onClick={toggle}>Contact</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      {isExpanded && (
        <Row className={'fr-contact'}>
          <Col xsmall={12} medium={5} nestedChild className={'fr-contact-more-info'}>
            {rep.briefBio && (
              <Fragment>
                <h5>About My Practice</h5>
                <p>
                  {rep.briefBio}
                </p>
              </Fragment>
            )}
            <h5 className='block'>Location</h5>
            <Link href={`https://maps.google.com/maps?q=loc:${rep.latitude},${rep.longitude}`} target='_blank' rel='nofollow noopener noreferrer'>
              {/* can add width 100% here to have the map maximized */}
              <picture>
                <source srcSet={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=250x414&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=${config.public.googlePlacesApiKey}`} media={PHONE_MEDIA_QUERY} />
                <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=534x282&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=${config.public.googlePlacesApiKey}`} alt='Google Map'/>
              </picture>
            </Link>
          </Col>
          <Col xsmall={12} medium={7} className={'fr-contact-service'}>
            <AgentForm
              agentnumber={rep.id}
              floodlightsendto={floodlightsendto}
              isPcg={false}
              useRecaptcha={false}
              formLocation="search"
              campaign={campaign}
              source={source}
              topic={topic}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

AgentCard.propTypes = {
  photoWidth: PropTypes.number,
  config: PropTypes.shape({
    public: PropTypes.shape({
      googlePlacesApiKey: PropTypes.string,
    }),
  }),
};

AgentCard.defaultProps = {
  config: {
    public: {
      googlePlacesApiKey: '<%=googlePlacesApiKey%>',
    },
  },
};

export default AgentCard;
